import { defineInterface } from '@nzyme/ioc/Interface.js';
export const FileMetadataLoader = defineInterface({
    name: 'FileMetadataLoader',
});
//# sourceMappingURL=FileMetadataLoader.js.map